import { useQuery } from '@apollo/client';
import { portfolioPermissionsAtom, selectedBakerFedIDAtom } from '@bakerweb/client-state';
import { PortfolioCustomerLevelDetail, PortfolioPermissions } from '@bakerweb/models';
import { removeTypename } from '@bakerweb/utils';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { GET_PORTFOLIO_CUSTOMER_LEVEL_DETAILS } from '../graphql/queries/getPortfolioCustomerLevelDetails';

export const useGetPortfolioCustomerLevelDetails = (portfolioCodes?: string[]) => {
  const [portfolioCustomerLevelDetails, setPortfolioCustomerLevelDetails] = useState<PortfolioCustomerLevelDetail[]>(
    []
  );

  const [bakerFedID, setBakerFedID] = useAtom(selectedBakerFedIDAtom);
  const setPortfolioPermissions = useSetAtom(portfolioPermissionsAtom);
  const shouldSkip = portfolioCodes?.some((code) => code === null || code === undefined);

  const { loading, error, data, refetch } = useQuery(GET_PORTFOLIO_CUSTOMER_LEVEL_DETAILS, {
    skip: shouldSkip,
    variables: { portfolioCodes, take: 5000 },
    fetchPolicy: 'cache-first'
  });

  useEffect(() => {
    if (data && data.portfolioCustomerLevelDetails) {
      setPortfolioCustomerLevelDetails(data.portfolioCustomerLevelDetails);
      setBakerFedID(data.portfolioCustomerLevelDetails[0]?.bakerFedID);
      setPortfolioPermissions(
        removeTypename(data.portfolioCustomerLevelDetails[0]?.permissions) as PortfolioPermissions
      );
    }
  }, [data]);

  return { loading, error, portfolioCustomerLevelDetails, refetch };
};
